import { render, staticRenderFns } from "./TheSettingsHeader.vue?vue&type=template&id=72ec72f0&scoped=true&"
import script from "./TheSettingsHeader.vue?vue&type=script&lang=js&"
export * from "./TheSettingsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheSettingsHeader.vue?vue&type=style&index=0&id=72ec72f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec72f0",
  null
  
)

export default component.exports